var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6819_10334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9093 1.09074C18.2059 0.387422 17.2707 7.8125e-05 16.2761 7.8125e-05L3.72398 0C1.67055 0.000117188 0 1.6707 3.90625e-05 3.72398L0 16.2761C3.90625e-05 18.3295 1.67062 20 3.72402 20H16.2761C18.3295 20 20 18.3295 20 16.2761V3.72402C20 2.7293 19.6127 1.7941 18.9093 1.09074ZM18.8281 16.2761C18.8281 17.6833 17.6833 18.8281 16.2761 18.8281H3.72402C2.3168 18.8281 1.17191 17.6832 1.17188 16.2761L1.17191 3.72395C1.17188 2.3168 2.31676 1.17195 3.72402 1.17188L16.2761 1.17195C16.9577 1.17195 17.5986 1.43738 18.0807 1.91938C18.5627 2.40141 18.8281 3.0423 18.8281 3.72402V16.2761Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5219 8.49578C13.2931 8.26699 12.9221 8.26695 12.6932 8.49578L10.5871 10.602L10.587 4.35156C10.587 4.02797 10.3247 3.76562 10.0011 3.76562C9.67748 3.76562 9.41514 4.02797 9.41514 4.35156L9.41518 10.6021L7.30885 8.49586C7.08006 8.26703 6.70904 8.26703 6.48021 8.49586C6.25139 8.72469 6.25139 9.09566 6.48021 9.32449L9.58678 12.431C9.69666 12.5409 9.84568 12.6026 10.0011 12.6026C10.1565 12.6026 10.3055 12.5409 10.4154 12.431L13.5219 9.32441C13.7507 9.09559 13.7507 8.72461 13.5219 8.49578Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6484 15.0625H4.35156C4.02797 15.0625 3.76562 15.3248 3.76562 15.6484C3.76562 15.972 4.02797 16.2344 4.35156 16.2344H15.6484C15.972 16.2344 16.2344 15.972 16.2344 15.6484C16.2344 15.3248 15.972 15.0625 15.6484 15.0625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6819_10334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.c537474ad9055bc81ec4a40c29c6b74b.svg";
export { ForwardRef as ReactComponent };